import { Pause, Play } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import cn from "~/utils/cn";

// Everyday story lines, each set in a different font from the app. Decorative sample type (aria-hidden).
const PHRASES = [
  { text: "صبح بخیر", cls: "font-display font-black text-[length:clamp(1.75rem,1.2rem+2.4vw,3rem)]" },
  { text: "دلم برات تنگ شده", cls: "font-alt text-[length:clamp(2rem,1.3rem+2.8vw,3.4rem)] leading-[1.3] [font-variation-settings:'wght'_300,'wdth'_70]" },
  { text: "تولدت مبارک", cls: "rounded-md bg-bg px-[.35em] font-alt text-[length:clamp(1.5rem,1.1rem+2vw,2.6rem)] [font-variation-settings:'wght'_800,'wdth'_100]" },
  { text: "امروز روز خوبیه", cls: "font-body font-light text-[length:clamp(1.6rem,1.1rem+2vw,2.6rem)]" },
  { text: "جمعه‌ها با رفیقا", cls: "font-display font-medium text-[length:clamp(1.6rem,1.1rem+2vw,2.6rem)]" },
];

// The page's one marquee: a tilted tape of live type, like a strip stuck across a story. Static under reduced motion;
// otherwise the button under its higher (start) end stops and restarts it (WCAG 2.2.2).
export default function Tape() {
  const { t } = useTranslation();
  const [playing, setPlaying] = useState(true);
  return (
    // the rotated tape is wider than the page; clip it sideways only, so its tilted edges are not cut off
    <div className="relative overflow-hidden py-[max(28px,3.2vw)] [@supports(overflow:clip)]:overflow-visible [@supports(overflow:clip)]:overflow-x-clip">
      <div aria-hidden className="-mx-[6%] w-[112%] -rotate-3 overflow-hidden bg-[#356bce] shadow-[0_24px_40px_-24px_rgba(5,9,45,.9)]">
        <div className="flex w-max motion-safe:animate-[c-tape_46s_linear_infinite]" style={playing ? undefined : { animationPlayState: "paused" }}>
          {[0, 1].map((g) => (
            <div key={g} className="flex items-center gap-7 p-3.5">
              {PHRASES.map((p) => (
                <span key={p.text} className="contents">
                  <span className={cn("whitespace-nowrap leading-[1.4] text-ink", p.cls)}>{p.text}</span>
                  <img src="/img/logo/white_bg_transparent_96.png" alt="" width={22} height={22} loading="lazy" className="size-[22px] opacity-85" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
      <button
        type="button"
        onClick={() => setPlaying((p) => !p)}
        aria-label={playing ? t("ui.landing.tape.pause") : t("ui.landing.tape.play")}
        className="absolute bottom-0 start-[var(--gutter)] grid size-11 place-items-center rounded-full bg-surface text-ink ring-1 ring-inset ring-line backdrop-blur-[12px] transition-colors duration-200 hover:bg-raised motion-reduce:hidden"
      >
        {playing ? <Pause className="size-[18px]" strokeWidth={1.75} aria-hidden /> : <Play className="size-[18px]" strokeWidth={1.75} aria-hidden />}
      </button>
    </div>
  );
}
